export default "__VITE_ASSET__BiTttUOb__"